import React from 'react';
import data from '../../ourDoctors.json';
// import { StarIcon } from '../../pages/MenoPauseResults';
const StarIcon = ({ size = 18, fill = "#F5A623", id }) => (
  <svg width={size} height={size} viewBox="0 0 24 24">
    {id && (
      <defs>
        <linearGradient id={id}>
          <stop offset="50%" stopColor="#F5A623" />
          <stop offset="50%" stopColor="#D6D0F7" />
        </linearGradient>
      </defs>
    )}
    <path
      d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
      fill={id ? `url(#${id})` : fill}
    />
  </svg>
);


const { doctorsList } = data;

const DoctorsList = () => {
  const { id, heading, items } = doctorsList;

  return (
    <section id={id} className="w-full bg-white ava-section-gap">
      {/* pb-12 */}
      <div className="container mx-auto px-4 md:px-8">
        <h2
          className="text-center ava-heading-lg ava-heading-gap"
        >
          {heading}
        </h2>

        {/* ── Doctor Cards ── */}
        <div className="flex flex-col gap-5 md:gap-6 max-w-[80%] mx-auto">
          {items.map((doctor) => (
            <DoctorCard key={doctor.id} doctor={doctor} />
          ))}
        </div>

      </div>
    </section>
  );
};

/* ── Individual Doctor Card ── */
const DoctorCard = ({ doctor, key }) => (
  <div
    className="flex flex-col sm:flex-row rounded-2xl overflow-hidden ava-card-bg ava-card-mukta"
  >
    {/* ── Left: Doctor photo ── */}
    <div
      // className="relative flex-shrink-0"
      // className="relative w-full sm:w-[260px] md:w-[280px] flex-shrink-0"
      className="relative w-full sm:w-[220px] md:w-[260px] lg:w-[280px] h-[220px] flex items-center justify-center  sm:h-auto flex-shrink-0"
      style={{ width: '100%', maxWidth: '280px', minHeight: '300px' }}
    >
      <img
        src={doctor.image}
        alt={doctor.name}
        className="w-full h-full object-cover object-top"
        // className="flex flex-col justify-center gap-3  flex-1 h-full object-center "
        // style={{ minHeight: '280px' }}
        draggable={false}
      />
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "14px" }}>
        <div
          style={{
            // position: "absolute",
            // bottom: "-16px",        // sits half-outside the bottom edge
            // left: "0%",
            // backgroundColor: "var(--primary-color)",
            // color: "#fff",
            // fontSize: "13px",
            // fontWeight: 500,
            // padding: "5px 10px",
            // borderRadius: "10px",
            // display: "flex",
            // alignItems: "center",
            // gap: "5px",
            position: "absolute",
            bottom: "52px",
            right: "2%",
            backgroundColor: " var(--primary-color)",
            color: "rgb(255, 255, 255)",
            fontSize: "13px",
            fontWeight: 500,
            padding: "5px 10px",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <StarIcon size={12} fill="white" />
          {doctor.rating}
        </div>
      </div>
      {/* Name overlay — bottom of photo */}

      <div className="absolute bottom-0 left-0 right-0 px-4 py-3 bg-[var(--secondary-color)] backdrop-blur-sm">
        <div className="relative  items-center flex-col gap-2">
          <p className="ava-text-subheading text-[white] font-semibold">
            {doctor.name}
          </p>

        </div>
      </div>
    </div>

    {/* ── Right: Doctor details ── */}
    <div className="flex flex-col justify-center gap-3 px-5 py-6 md:px-8 md:py-7 flex-1">

      {/* Designation */}
      <p
        className="ava-text-subheading"
      >
        {doctor.designation}
      </p>
      {/* Location */}
      {doctor.location && (
        <div className="flex items-center gap-1.5">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-[var(--ava-primary)] shrink-0"
            aria-hidden="true"
          >
            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
            <circle cx="12" cy="10" r="3" />
          </svg>


          {doctor.href ? (
            <a
              href={doctor.href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[var(--ava-primary)] hover:underline ava-text-body"
            >
              {doctor.location}
            </a>
          ) : <p className="ava-text-body text-gray-600">
            {doctor.location}
          </p>}
        </div>
      )}
      {/* Experience */}
      <p
        className="ava-text-body"
      >
        <span className="font-semibold">Experience:</span>{' '}
        <span>{doctor.experience}</span>
      </p>

      {/* Bio */}
      <p
        className="ava-text-body"
      >
        {doctor.bio}
      </p>

      {/* Specializations */}
      {doctor.specializations && doctor.specializations.length > 0 && (
        <p
          className="ava-text-body"
        >
          <span className="font-semibold">Specializations: </span>
          {doctor.specializations.map((spec, i) => (
            <React.Fragment key={i}>
              <span>{spec}</span>
              {i < doctor.specializations.length - 1 && (
                <span className="mx-1.5 ">|</span>
              )}
            </React.Fragment>
          ))}
        </p>
      )}

      {/* Book button */}
      <div className="mt-1">
        <a
          href={doctor.bookingHref || '#book'}
          className="btn-primary"
        // style={{ padding: '0.55rem 1.5rem' }}
        >
          {doctor.bookingLabel || 'Book An Appointment'}
        </a>
      </div>

    </div>
  </div>
);

export default DoctorsList;